module.exports = __webpack_public_path__ + "static/media/white_category_icon_c5.807136c9.svg";